import { useState, useEffect, useRef, useContext } from "react";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { referLeadToEntity } from "@/modules/lead-page/api/lead-page.api";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { SquareArrowOutUpRight } from "lucide-react";
import { muiTheme } from "@/styles/theme";

const useReferToEntity = () => {
  const { lead } = useContext(LeadPageContext);
  const [isConfirmTransferOpen, setIsConfirmTransferOpen] = useState(false);
  const [entityName, setEntityName] = useState("");
  const [entityKey, setEntityKey] = useState("");
  const [isFeedBackModalOpen, setIsFeedBackModalOpen] = useState(false);
  const queryClient = useQueryClient();

  const { mutate, isLoading, isError } = useMutation({
    mutationFn: ({
      leadId,
      entityName,
    }: {
      leadId: number | undefined;
      entityName: string;
    }) => referLeadToEntity(leadId, entityName),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getLead"] });
      setIsConfirmTransferOpen(false);
      setIsFeedBackModalOpen(true);
    },
    onError: () => {
      setIsConfirmTransferOpen(false);
      setIsFeedBackModalOpen(true);
    },
  });

  const referToEntity = (entityName: string) => {
    mutate({ leadId: lead?.data?.lead.id, entityName: entityName });
  };

  const dropdownRef: any = useRef(null);
  const [toggleReferTo, setToggleReferTo] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setToggleReferTo(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleIsConfirmModalOpen = (entityName: string, entityKey: string) => {
    setEntityName(entityName);
    setEntityKey(entityKey);
    setIsConfirmTransferOpen(!isConfirmTransferOpen);
  };

  const referToList = [
    {
      name: "Refer To Taskeen",
      icon: (
        <SquareArrowOutUpRight
          style={{
            color: muiTheme.colorSchemes.light.palette.primary[500],
            width: "20px",
            height: "20px",
          }}
        />
      ),
      color: "#015C9A",
      onClick: () => handleIsConfirmModalOpen("Taskeen", "transfer_to_taskeen"),
    },
    {
      name: "Refer To Key",
      icon: (
        <SquareArrowOutUpRight
          style={{
            color: muiTheme.colorSchemes.light.palette.primary[500],
            width: "20px",
            height: "20px",
          }}
        />
      ),
      color: "#015C9A",
      onClick: () => handleIsConfirmModalOpen("Key", "transfer_to_key"),
    },
  ];

  return {
    isConfirmTransferOpen,
    entityName,
    entityKey,
    isFeedBackModalOpen,
    setIsFeedBackModalOpen,
    referToEntity,
    dropdownRef,
    toggleReferTo,
    setToggleReferTo,
    handleIsConfirmModalOpen,
    referToList,
    isLoading,
    isError,
  };
};

export default useReferToEntity;
